import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { WebSocketProvider } from '@/components/WebSocketProvider'
import App from './App'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,            // 30s cache (increased from 5s)
      refetchOnWindowFocus: false,  // Don't refetch when user returns to tab
      refetchInterval: false,       // Don't auto-refetch by default
      refetchOnMount: true,         // DO refetch when component mounts
      refetchOnReconnect: true,     // DO refetch when reconnecting
      retry: 1,                     // Only retry once on failure
    },
  },
})

const basename = import.meta.env.VITE_ROUTER_BASENAME || '/'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <WebSocketProvider>
        <BrowserRouter basename={basename}>
          <App />
        </BrowserRouter>
      </WebSocketProvider>
    </QueryClientProvider>
  </StrictMode>,
)
